import { render, staticRenderFns } from "./exchange-rate-card.vue?vue&type=template&id=321d4ca6&scoped=true&lang=pug"
import script from "./exchange-rate-card.vue?vue&type=script&lang=js"
export * from "./exchange-rate-card.vue?vue&type=script&lang=js"
import style0 from "./exchange-rate-card.vue?vue&type=style&index=0&id=321d4ca6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321d4ca6",
  null
  
)

export default component.exports